// Model.js
// -----------------------
// @module RentFromAnywhere
define("Ames.RentFromAnywhere.RentFromAnywhere.SS2Model", ["Backbone", "Utils", "jQuery"], function(
    Backbone,
    Utils,
    jQuery
) {
    "use strict";

    // @class Ames.RentFromAnywhere.RentFromAnywhere.SS2Model @extends Backbone.Model
    var Model = Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/RentFromAnywhere/SuiteScript2/RentFromAnywhere.Service.ss"
            ),
            true
        )
    });

    // Order-level rental info, fetched ONCE per order and shared by every view
    // on the page (order header, each line, the actions cell). Resolves with
    // the service response when the order is a rental order (orderStatus set),
    // or with null for a normal order / on error. Never rejects.
    var orderCache = {};
    Model.orderInfo = function (orderId) {
        var id = String(orderId || "").split("_")[0];
        if (!id) return jQuery.Deferred().resolve(null).promise();
        if (!orderCache[id]) {
            orderCache[id] = new Model()
                .fetch({ data: { orderId: id, index: 0 } })
                .then(
                    function (resp) {
                        return resp && resp.orderStatus !== null && resp.orderStatus !== undefined ? resp : null;
                    },
                    function () {
                        return jQuery.Deferred().resolve(null);
                    }
                );
        }
        return orderCache[id];
    };

    // Forget a cached order (after an action that changes it, so the next
    // view reads fresh data)
    Model.forgetOrder = function (orderId) {
        delete orderCache[String(orderId || "").split("_")[0]];
    };

    return Model;
});
